import { mapGetters, mapActions } from "vuex";
import {
    Drag,
    Drop
} from "vue-easy-dnd";
import DropDownDestinataires from '../DropDownDestinataires/DropDownDestinataires.vue';

export default {
    name: "FileDrop",
    components: {Drag, Drop, DropDownDestinataires},
    props: ['files', 'fileObjectTab', 'produitSelect', 'lastOrder', 'destinataires', 'isSuivi'],

    computed: {
        ...mapGetters(["auth"]),

        isAdmin() {
            if(this.auth && this.auth.user && this.auth.user.roles && 
                this.auth.user.roles.find((role) => role.name === "admin")) {
                return true
            }
            return false
        },

        isSousCategorieSansDestinataire() {
            return this.files.find((f) => f.title.startsWith("Destinataires")) == undefined ;
        },

        alertFile() {
            if (this.filesWaiting.length > 0 && this.fileSelect >= 0) {
                return this.filesWaiting[this.fileSelect].alert;
            } else {
                return false;
            }
        },

        filesNoTri() {
            if (this.produitSelect === 'letreco') {                
                this.files.forEach(composante => {                    
                    composante.children.sort((a,b) => {
                        let aName = a.title
                        let bName = b.title
                        if(a.destinataire && ((a.destinataire.length > 0 && a.destinataire[0].mail == "all") || a.destinataire.length == 0)) {                            
                            aName = "   "+aName
                        }
                        if(b.destinataire && ((b.destinataire.length > 0 && b.destinataire[0].mail == "all") || b.destinataire.length == 0)) {
                            bName = "   "+bName
                        }
                        return aName.localeCompare(bName)
                    })
                })
            }
            return this.files.filter(f => f.isWaitingNode === false)
        },
    },

    data() {
        return {
            filesWaiting: [],
            filesToSort: [],
            objectURL: "",
            dragging: false,
            dragover: null,
            isErrorOptionComposante: false,
            currentDrop: null,
            fileSelect: 0,
        }
    },

    methods: {
        ...mapActions([
            'uploadFiles', 'extractDestinataires'
        ]),

        showModal() {
            this.$refs.list.show();
        },

        loadLastOrderDocument() {
            if (this.lastOrder && this.lastOrder.id) {
              let groupeSelect = [];
              let optionSelect = [];
              let fileSelect = [];
              this.lastOrder.commande_has_groupe_options.forEach(groupeOption => {
                fileSelect = this.files.filter(file => {
                  return file.id && file.id == groupeOption.composante_id
                })
                if(fileSelect[0]) {
                  groupeSelect = fileSelect[0].options.filter(groupe => {
                    return groupe.groupe.id == groupeOption.groupe_option.groupe_id
                  })
                  if(groupeSelect[0]) {
                    optionSelect = groupeSelect[0].groupe.groupe_options.filter(option => {
                      return option.id == groupeOption.groupe_option_id;
                    })
                    groupeSelect[0].groupe.value = optionSelect[0].libelle;
                    optionSelect[0].selected = true;
                  }
                }
              });
            }
        },

        /* Preview an uploaded file */
        previewElement(file){
            let fileObject = this.fileObjectTab.find(el => {return el.id === file.id});
            this.objectURL = window.URL.createObjectURL(fileObject);
            let extension = fileObject.name.split(".").pop().toLowerCase();
            if(extension == "jpg" || extension == "jpeg" || extension == "png" || extension == "pdf") {                
                this.$refs.objectURLviewer.show();
            } else {
                const elem = window.document.createElement('a');
                elem.href = this.objectURL;
                elem.download = fileObject.name;        
                document.body.appendChild(elem);
                elem.click();        
                document.body.removeChild(elem);
            }
        },

         /**
         * Fonction permettant de modifier les paramètres d'impression de la composante.
         * @param {*} composante
         */
         editComposante(composante) {
            this.dragover = composante
            if (!composante.noParam) {
              this.modeEdit = true;
              this.fileSelect = 0;
              this.$refs['list'].show()
            }
        },
        
        /**
         * Fonction permettant de valider les paramètres d'une composante et de déplacer le fichier vers le document désiré.
         */
        validerComposante() {
            this.isErrorOptionComposante = false
            let vm = this
            let indice = this.files.findIndex(function (compo) {
                return compo.title == vm.currentDrop.composante;
            });
            if (indice >= 0) {
                let indice2 = this.files[indice].children.findIndex(function (file) {
                    return vm.currentDrop.title == file.title;
                });
                if (indice2 >= 0) {
                    // Vérification des options
                    if (!this.dragover.isWaitingNode && !this.dragover.noParam) {
                        this.dragover.options.forEach(aOption => {
                            let isOneSelected = false
                            aOption.groupe.groupe_options.forEach(aGroupeOption => {
                                if (aGroupeOption.selected) {
                                    isOneSelected = true
                                }
                            })
                            if (!isOneSelected) {
                                this.isErrorOptionComposante = true
                            }
                        })
                    }
                    if (this.dragover && !this.isErrorOptionComposante) {
                        this.currentDrop.composante = this.dragover.title
                        this.currentDrop.destinataire = []
                        if (indice !== 0) {
                            this.files[indice].children.splice(indice2, 1)
                            this.dragover.children.push(this.currentDrop)
                        } else {
                            this.files[indice].children.forEach(el => {
                                el.composante = this.dragover.title
                                this.dragover.children.push(el)
                            })
                            this.files[indice].children = []
                        }
                        this.dragover.isAlreadyConfigured = true
                        this.$refs['list'].hide()
                    }
                }
            }
        },

        /**
         * Descendre un fichier.
         */
        clicDown(composante, file, indice) {
            if (indice < composante.children.length - 1) {
                composante.children.splice(indice, 2, composante.children[indice + 1], file)
            }
        },
        /**
         * Monter un fichier.
         */
        clicUp(composante, file, indice) {
            if (indice > 0) {
                composante.children.splice(indice - 1, 2, file, composante.children[indice - 1])
            }
        },

        /**
         * Supprimer un fichier.
         */
        deleteElement(composante, indice) {           
            const indexInFW = this.filesWaiting.findIndex(el => el.id == composante.children[indice].id)
            if(indexInFW > -1) {
                this.filesWaiting.splice(indexInFW, 1)
            }
            const indexInFOT = this.fileObjectTab.findIndex(el => el.id === composante.children[indice].id)
            if(indexInFOT > -1) {
                this.fileObjectTab.splice(indexInFOT, 1)
            }
            composante.children.splice(indice, 1);
        },

        /**
         * Fonction pour annuler la configuratio, de la composante.
        */
        annulerConfigComposante() {
            this.filesWaiting = [];
            this.$refs['list'].hide()
        },

        /**
         * Fonction permettant d'ajouter les fichiers dans la zone "à trier".
         */
        ajouterFichierATrier() {
            if (!this.modeEdit) {
                if (this.filesWaiting[this.fileSelect] && !this.filesWaiting[this.fileSelect].alert) {
                    this.filesWaiting.forEach(file => { file.destinataire = [] })
                    Array.prototype.push.apply(this.files[0].children, JSON.parse(JSON.stringify(this.filesWaiting)));
                    this.modeEdit = false;
                    this.filesWaiting = [];
                    this.$refs['list'].hide()
                }
            } else {
                this.modeEdit = false;
                this.filesWaiting = [];
                this.$refs['list'].hide()
            }
        },

        addFileDnD(e) {
            let droppedFiles = e.dataTransfer.files;
            if (!droppedFiles) return;
            ([...droppedFiles]).forEach(f => {
                this.pushFileArray(f);
            });
            this.fileSelect = 0;
            this.dragging = false;
            this.ajouterFichierATrier()
        },

        addFileBtn(event) {
            for (let i = 0; i < event.target.files.length; i++) {
                this.pushFileArray(event.target.files[i]);
            }
            this.fileSelect = 0;
            this.ajouterFichierATrier()
            event.target.value = ''
        },

        removeFile(file) {
            this.files = this.files.filter(f => {
                return f != file;
            });
        },

        pushFileArray(f) {
            let type = f.name.split('.').pop().toLowerCase()
            if((type === 'xlsx' || type === 'txt') && !this.isSousCategorieSansDestinataire && !this.isSuivi) {
                // Si c'est un excel, on l'envoie au serveur pour recupérer les destinataires
                this.loadingDestinataires = true
                let formData = new FormData();
                formData.append('file1', f);
                this.uploadFiles(formData).then(response => {
                    this.extractDestinataires(response.data[0].path).then(response => {
                        // this.destinataires.splice(0,this.destinataires.length)
                        this.destinataires.push(...response.data)
                        if(this.produitSelect === 'letreco') {
                            this.destinataires.forEach(d => d.electronique = 1)
                        }
                        this.addFileDestinataire(f)
                        if(response.data && response.data.length > 0 && response.data[0].numero) {
                            this.numero = response.data[0].numero
                        }
                        this.loadingDestinataires = false
                    }).catch(() => {
                        this.loadingDestinataires = false
                        this.addFile(f)
                        this.ajouterFichierATrier()
                    })
                }).catch(() => {
                    this.loadingDestinataires = false
                })
            } else {
                this.addFile(f)
            }
        },

        selectDestinataire({file, dest}) {
            file.destinataire.splice(0, file.destinataire.length, dest)
            // forcer vue à déclencher la réactivité en créant / supprimant une clef dans l'objet
            const dummyKey = '_u'+Date.now()
            this.$set(file, dummyKey, 'updated')
            this.$nextTick(() => {delete file[dummyKey]})
            this.$emit('destinataire-selected', {file, dest})
        },

        addFile(f) {
            let type = f.name.split('.').pop()
            const id = f.name + "_" + Math.random().toString(16).slice(2)
            let file = {}
            file.title = f.name
            file.id = id
            file.type = type
            file.composante = this.files[0].title
            file.children = []
            file.destinataire = []
            file.options = []
            file.file = f
            f.id = id
            this.fileObjectTab.push(f)
            file.alert = false
            if(this.produitSelect === 'letreco') { // si LetReco on met direct dans le dossier Documents
                file.composante = "Document(s) à envoyer"
                this.files.find(composante => composante.title === "Document(s) à envoyer").children.push(file)
            }else{
                this.filesWaiting.push(file)
            }            
        },

        addFileDestinataire(f) {
            let type = f.name.split('.').pop()
            const id = f.name + "_" + Math.random().toString(16).slice(2)
            let file = {}
            file.title = f.name
            file.id = id
            file.type = type
            file.composante = "Destinataires"
            file.children = []
            file.options = []
            file.destinataire = []
            file.file = f
            f.id = id
            this.files.find(composante => composante.title === "Destinataires").children.push(file)
            this.fileObjectTab.push(f)
        },

        /**
         * Fonction utilsée pour déplacer un fichier vers un document avec le drag and drop.
         * @param {*} event
         */
        onDrop(event) {
            // Ouverture de la modale pour configurer les options de la composante si cela n'a pas encore été réalisé
            this.currentDrop = event.data
            if (this.dragover.isAlreadyConfigured || this.dragover.noParam || this.dragover.options.length == 0) {
                this.validerComposante()
            } else {
                this.loadLastOrderDocument()
                this.showModal()
            }
        },

        /**
         * Fonction utilsée pour déplacer un fichier vers un document sans utiliser le drag and drop.
         * @param {*} target
         */
        deplacerDocument(target) {
            this.dragover = target
            this.$refs.deplacement_doc.hide()
            if (this.dragover.isAlreadyConfigured 
                    || this.dragover.isWaitingNode || this.dragover.noParam 
                    || this.dragover.options.length == 0) {
                this.validerComposante()
            } else {
                this.loadLastOrderDocument()
                this.showModal()
            }
        },

        /**
         * Fonciton pour ouvrir la modale de déplacement de fichier (pour mobile).
         * @param {*} pFile
         */
        openModalDeplaceElement(pFile) {
            this.currentDrop = pFile
            if(this.filesNoTri.length > 1) {
                this.$refs.deplacement_doc.show()
            } else {
                this.deplacerDocument(this.filesNoTri[0])
            }
        },

        /**
         * Fonction popur fermer la modale de déplacement (pour mobile).
         */
        closeModalDeplaceElement() {
            this.$refs.deplacement_doc.hide()
        },

        selectionneOptionRadio(option) {
            //on cherche le groupe auquel appartient l'option
            let indice = this.categorieEnveloppe.findIndex(function (groupe) {
              return groupe.groupe_id == option.groupe_id;
            });
            if (indice >= 0) {
              //on déselectionne les options et on sélectionne les autres
              this.categorieEnveloppe[indice].groupe.probleme = false
              this.categorieEnveloppe[indice].groupe.groupe_options.forEach(groupeOption => {
                groupeOption.selected = false;
                if (groupeOption.id == option.id) {
                  groupeOption.selected = true;
                  this.categorieEnveloppe[indice].groupe.value = groupeOption.libelle
                }
              });
            }
        },

        selectionneOptionRadioFile(option) {
            // //on cherche le groupe auquel appartient l'option
            let indice = this.dragover.options.findIndex(function (groupe) {
                return groupe.groupe_id == option.groupe_id;
            });
            if (indice >= 0) {
                //on déselectionne les options et on sélectionne les autres
                this.dragover.options[indice].groupe.groupe_options.forEach(groupeOption => {
                    groupeOption.selected = false;
                    if (groupeOption.id == option.id) {
                        groupeOption.selected = true;
                        this.dragover.options[indice].groupe.value = groupeOption.libelle
                    }

                });
            }
        },

        selectionneOptionSelect(id, group, event) {
            // Recalcul du délai de livraison si groupe affranchissement
            let selectedGroupOptions = group.groupe_options.find(element => element.libelle === event)
            if(group.libelle === "Affranchissement") {
                this.dateEstimee = this.calculateDateEstimee({date_remise_en_poste: this.dateRemise}, selectedGroupOptions);                
            }
            group.probleme = false
            group.groupe_options.forEach(option => {                
                if(event === option.libelle) {
                    option.selected = true;
                } else {
                    option.selected = false;
                }
            });
        },

        selectionneOptionSelectFile(id, index) {
            this.dragover.options[index].groupe.groupe_options.forEach(option => {
                option.selected = false;
            });
            this.dragover.options[index].groupe.groupe_options[this.$refs['o_' + id][0].selectedIndex].selected = true;
        },

    },

    watch: {
        fileObjectTab: function(update) {
            if(this.files[0].children.length > 0 && this.isSuivi === false) {
                this.openModalDeplaceElement(this.files[0].children[0]);
            }
            this.fileTabLength = update.length;
        },
    },
}